import React from 'react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { AdvancedMarker } from '@vis.gl/react-google-maps'; // Import AdvancedMarker
import { useColorScheme } from '@mui/material/styles';
import ImageMarker from './ImageMarker';

function AboutMap() {
    const { mode } = useColorScheme();
    const colorSchemeMap = { light: "LIGHT", dark: "DARK", system: "FOLLOW_SYSTEM" };
    const position1 = { lat: 28.370108, lng: 76.922603 };
    // Function to get the mapped value from the dictionary 
    function getColorScheme(value) { return colorSchemeMap[value] || "UNKNOWN_SCHEME"; }

    return (
        <APIProvider apiKey="AIzaSyBrofpZ8fdySj8Hn5rOc6jepjSZemsjHRo"> {/* Replace with your actual API key */}
            <Map
                mapContainerStyle={{ width: '100vw', height: '400px', borderRadius: '50px', }}
                initialCenter={position1}
                defaultCenter={{ lat: 28.370108, lng: 76.922603 }}
                defaultZoom={12}
                gestureHandling={'greedy'}
                disableDefaultUI={true}
                mapId={'2d5d07f22b694022'}
                reuseMaps={true}
                colorScheme={colorSchemeMap[mode]}
            >
                <AdvancedMarker position={position1}>
                    <ImageMarker imageSrc='/maskable-icons/maskable_icon_x48.png' pinColor='rgb(254 203 58)' borderRadius='50%' />
                </AdvancedMarker>
            </Map>
        </APIProvider>
    );
}

export default AboutMap;